import { Navigate } from 'react-router-dom';

import { NBA_LIVE_PRO_COMPETITIONS } from '@sorare/core/src/constants/__generated__/routes';

const Page = () => <Navigate to={NBA_LIVE_PRO_COMPETITIONS} replace />;

export default Page;
